import type { I18nString } from "@/shared/types/audit";
import type { Locale } from "./types";

export function getLocalizedTargetRepr(repr: string | I18nString | null | undefined, locale: Locale): string {
  if (!repr) return "";
  if (typeof repr === "string") return repr;
  return repr[locale] ?? repr.ru ?? "";
}
